import React from 'react';

const ValuesManagerSkeleton = () => {
  return (
    <div className="container mx-auto p-6">
      <div className="mb-6">
        <div className="flex justify-between items-center mb-4">
          <div className="h-8 bg-base-200 rounded skeleton animate-pulse w-36"></div>
          <div className="h-10 bg-base-200 rounded skeleton animate-pulse w-32"></div>
        </div>
        
        <div className="card bg-base-100 shadow-sm rounded-2xl p-6 mb-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="text-center p-4 bg-base-50 rounded-lg">
                <div className="h-12 w-12 bg-base-200 rounded-full skeleton animate-pulse mx-auto mb-3"></div>
                <div className="h-5 bg-base-200 rounded skeleton animate-pulse w-20 mx-auto mb-2"></div>
                <div className="h-4 bg-base-200 rounded skeleton animate-pulse w-28 mx-auto mb-3"></div>
                <div className="flex justify-center gap-2">
                  <div className="h-6 w-6 bg-base-200 rounded skeleton animate-pulse"></div>
                  <div className="h-6 w-6 bg-base-200 rounded skeleton animate-pulse"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="card bg-base-100 shadow-sm rounded-2xl p-6">
            <div className="h-6 bg-base-200 rounded skeleton animate-pulse w-40 mb-4"></div>
            
            <div className="space-y-3">
              {[...Array(5)].map((_, i) => (
                <div key={i} className="flex items-center justify-between p-3 border border-base-200 rounded-lg">
                  <div className="flex items-center gap-3">
                    <div className="h-8 w-8 bg-base-200 rounded skeleton animate-pulse"></div>
                    <div>
                      <div className="h-4 bg-base-200 rounded skeleton animate-pulse w-24 mb-1"></div>
                      <div className="h-3 bg-base-200 rounded skeleton animate-pulse w-32"></div>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <div className="h-8 w-8 bg-base-200 rounded skeleton animate-pulse"></div>
                    <div className="h-8 w-8 bg-base-200 rounded skeleton animate-pulse"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="card bg-base-100 shadow-sm rounded-2xl p-6">
            <div className="h-6 bg-base-200 rounded skeleton animate-pulse w-44 mb-4"></div>
            
            <div className="space-y-4">
              <div className="p-4 bg-base-50 rounded-lg">
                <div className="h-4 bg-base-200 rounded skeleton animate-pulse w-full mb-2"></div>
                <div className="h-4 bg-base-200 rounded skeleton animate-pulse w-5/6 mb-3"></div>
                <div className="h-8 bg-base-200 rounded skeleton animate-pulse w-32"></div>
              </div>
              
              <div className="p-4 bg-base-50 rounded-lg">
                <div className="h-4 bg-base-200 rounded skeleton animate-pulse w-full mb-2"></div>
                <div className="h-4 bg-base-200 rounded skeleton animate-pulse w-4/5 mb-3"></div>
                <div className="h-8 bg-base-200 rounded skeleton animate-pulse w-28"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValuesManagerSkeleton;